import React, { useState, useEffect } from "react";
import "../Styles/Home.css";
import { dataFormatter } from "../../constant/condition";
import { Link } from "react-router-dom";
import config from "../../config/Config";
import { Helmet } from "react-helmet";
import "react-country-state-city/dist/react-country-state-city.css";
import Loader from "./Loader";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { CardImageThumb } from "./CardImageThumb";

export default function Home() {
  const [data, setData] = useState([]);
  const [datas, setDatas] = useState([]);
  const [configuration, setConfiguration] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [allData, setAllData] = useState([]);
  const [allDatas, setAllDatas] = useState([]);
  const [visibleCount, setVisibleCount] = useState(4);
  const [seriesCount, setSeriesCount] = useState(4);
  const [imageLightboxSrc, setImageLightboxSrc] = useState(null);
  // function fetchData() {
  //   fetch(`${config.API_BLOG}getdata`)
  //     .then((result) => {
  //       result.json().then((res) => {
  //         setData(res);
  //         setIsLoading(false);
  //       });
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       setIsLoading(false);
  //     });
  // }

  function fetchData() {
    fetch(`${config.API_BLOG}getdata`)
      .then((result) => result.json())
      .then((res) => {
        const sortedData = res.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at),
        );

        setAllData(sortedData);
        setData(sortedData.slice(0, 4));
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  }

  // function fetchSeriesData() {
  //   fetch(`${config.API_TUTORIAL}getseries`)
  //     .then((result) => {
  //       result.json().then((res) => {
  //         setDatas(res);
  //         setIsLoading(false);
  //       });
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       setIsLoading(false);
  //     });
  // }

  function fetchSeriesData() {
    fetch(`${config.API_TUTORIAL}getseries`)
      .then((result) => {
        result.json().then((res) => {
          const sortedDatas = res.sort((a, b) => b.id - a.id);

          setAllDatas(sortedDatas);
          setDatas(sortedDatas.slice(0, 4));
          setIsLoading(false);
        });
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  }

  const toSlug = (title) => {
    return title
      .toLowerCase()
      .replace(/ /g, "-")
      .replace(/[^\w-]+/g, "");
  };

  function fetchConfiguration() {
    fetch(`${config.API_BLOG}configuration`)
      .then((result) => result.json())
      .then((res) => {
        setConfiguration(res);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching configuration:", err);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    setIsLoading(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchData();
    fetchSeriesData();
    fetchConfiguration();
  }, []);

  useEffect(() => {
    setData(allData.slice(0, visibleCount));
    setDatas(allDatas.slice(0, seriesCount));
  }, [visibleCount, allData, seriesCount, allDatas]);

  const metaTitle = configuration[0]?.default_meta_title;
  const metaKeywords = configuration[0]?.default_meta_keywords;
  const metaDescription = configuration[0]?.default_meta_description;

  const renderHTML = (rawHTML) => {
    return { __html: rawHTML };
  };

  const siteLabel =
    configuration[0]?.default_meta_title?.split("|")[0]?.trim() || "iLearnings";

  return (
    <div className="container-fluid mt-4 mb-4 page-shell home-page">
      <Helmet>
        <title>ilearnings</title>
        <meta name="title" content={metaTitle} />
        <meta name="keywords" content={metaKeywords} />
        <meta name="description" content={metaDescription} />
      </Helmet>

      {isLoading ? (
        <div className="text-center mt-5 py-5">
          <Loader />
        </div>
      ) : (
        <>
          <section className="home-hero" data-aos="fade-up">
            <div className="home-hero__inner">
              <span className="home-hero__badge">Learn · Build · Grow</span>
              <h1 className="home-hero__title">
                Welcome to{" "}
                <span className="home-hero__accent">{siteLabel}</span>
              </h1>
              <p className="home-hero__lead">
                Fresh blogs, hands-on tutorials, and series on modern web tech —
                written to help you ship better code with clarity and
                confidence.
              </p>
              <div className="home-hero__stats">
                <div className="home-hero__stat">
                  <span className="home-hero__stat-value">
                    <Link to="/blog" className="home-hero__btn-ghost px-4">
                      {allData.length}
                    </Link>
                  </span>
                  <span className="home-hero__stat-label">Blog posts</span>
                </div>
                <div className="home-hero__stat">
                  <span className="home-hero__stat-value">
                    <Link to="/tutorialseries" className="home-hero__btn-ghost">
                      {allDatas.length}
                    </Link>
                  </span>
                  <span className="home-hero__stat-label">Tutorial series</span>
                </div>
              </div>
            </div>
          </section>

          <section className="home-section" aria-labelledby="home-blog-heading">
            <div className="home-section__head" data-aos="fade-up">
              <center style={{ fontSize: "38px", fontFamily: "sofia" }}>
                <b>
                  Latest <b style={{ color: "#173a9b" }}>articles</b>
                </b>
                <hr
                  className="w-25 mx-auto"
                  style={{ transform: "translateY(-16px)" }}
                />
              </center>
            </div>
            <div className="row g-4 home-card-grid justify-content-center">
              {/* <div
                  style={{
                    fontSize: "26px",
                    fontFamily: "sofia",
                  }}
                >
                  <b className="heading_font">
                    {data.length} Of {allData.length} Latest Blog Posts
                  </b>
                </div> */}
              {data.map((item, index) => {
                let newTypeDate = dataFormatter(item.published_date);
                //word count
                {
                  /* const limitedContent = (() => {
                    const parser = new DOMParser();
                    const plainText =
                      parser.parseFromString(item.post_content, "text/html")
                        .body.textContent || "";
                    return (
                      plainText.split(/\s+/).slice(0, 40).join(" ") +
                      (plainText.split(/\s+/).length > 40 ? "..." : "")
                    );
                  })(); */
                }

                //letter count
                const limitedContent = (() => {
                  const parser = new DOMParser();
                  const plainText =
                    parser.parseFromString(item.post_content, "text/html").body
                      .textContent || "";
                  const letterOnlyText = plainText.replace(/[^a-zA-Z ]/g, "");
                  let letterCount = 0;
                  let limitedText = "";
                  for (let i = 0; i < letterOnlyText.length; i++) {
                    if (/[a-zA-Z]/.test(letterOnlyText[i])) {
                      letterCount++;
                    }
                    if (letterCount <= 200) {
                      limitedText += letterOnlyText[i];
                    } else {
                    }
                  }
                  return limitedText + (letterCount > 200 ? "..." : "");
                })();

                return (
                  <div
                    className="col-12 col-xl-6 card_box"
                    style={{ transform: "translateY(-25px)" }}
                    key={item.post_id}
                    data-aos="fade-up"
                    data-aos-delay={Math.min(index * 70, 350)}
                  >
                    <article
                      className="card home-card h-100"
                      style={{ border: "1px solid rgba(23, 58, 155, 0.18)" }}
                    >
                      <div className="home-card__body">
                        <div className="home-card__thumb">
                          <CardImageThumb
                            src={item.post_banner_b64}
                            alt={item.post_title}
                            onOpen={setImageLightboxSrc}
                          />
                        </div>
                        <div className="home-card__content">
                          <Link
                            to={`/read/${toSlug(item.post_title)}`}
                            state={{ item }}
                            onClick={() => {
                              localStorage.setItem("post_id", item.post_id);
                            }}
                            className="home-card__title"
                          >
                            {item.post_title}
                          </Link>
                          <div
                            className="home-card__excerpt para_font_family"
                            dangerouslySetInnerHTML={renderHTML(limitedContent)}
                          />
                          <Link
                            to={`/read/${toSlug(item.post_title)}`}
                            state={{ item }}
                            onClick={() => {
                              localStorage.setItem("post_id", item.post_id);
                            }}
                            className="home-card__read"
                          >
                            Read more →
                          </Link>
                        </div>
                      </div>
                      <div className="home-card__tags">
                        <div className="tags-container">
                          {item.tags.map((tag) => (
                            <Link
                              key={tag.tag_id}
                              to={`/blog/tag/${toSlug(tag.tag_name)}`}
                              state={{ item }}
                              className="tag-link"
                            >
                              <button type="button" className="tag-button">
                                {tag.tag_name} ({tag.posts_count})
                              </button>
                            </Link>
                          ))}
                        </div>
                        <div className="home-card__footer">
                          <div className="home-card__footer-inner para_font_family text-light">
                            <p style={{ textTransform: "capitalize" }}>
                              <b>By</b> {item.name}
                            </p>
                            <p>
                              <b>On</b> {newTypeDate}
                            </p>
                          </div>
                        </div>
                      </div>
                    </article>
                  </div>
                );
              })}
            </div>
            {data.length < allData.length && (
              <div className="text-center mt-2 pt-2" data-aos="zoom-in">
                <button
                  type="button"
                  className="btn btn-dark  px-5 rounded-pill"
                  onClick={() => setVisibleCount(visibleCount + 4)}
                >
                  Load more articles
                </button>
              </div>
            )}
          </section>

          <section
            className="home-section"
            aria-labelledby="home-tutorial-heading"
          >
            <div className="home-section__head" data-aos="fade-up">
              <center
                style={{
                  fontSize: "38px",
                  fontFamily: "sofia",
                  transform: "translateY(-25px)",
                }}
              >
                <b>
                  Tutorial <b style={{ color: "#173a9b" }}>series </b>
                </b>
                <hr
                  className="w-25 mx-auto"
                  style={{ transform: "translateY(-16px)" }}
                />
              </center>
            </div>
            <div
              className="row g-4 home-card-grid justify-content-center"
              style={{ transform: "translateY(-25px)" }}
            >
              {/* <b className="heading_font">
                  {datas.length} Of {allDatas.length} Tutorial Series
                </b> */}
              {datas.map((item, index) => {
                //word count
                {
                  /* const limitedContentTutorials = (() => {
                    const parser = new DOMParser();
                    const plainText =
                      parser.parseFromString(
                        item.tutorial_series_description,
                        "text/html"
                      ).body.textContent || "";
                    return (
                      plainText.split(/\s+/).slice(0, 40).join(" ") +
                      (plainText.split(/\s+/).length > 40 ? "..." : "")
                    );
                  })(); */
                }

                //letter count
                const limitedContentTutorials = (() => {
                  const parser = new DOMParser();
                  const plainText =
                    parser.parseFromString(
                      item.tutorial_series_description,
                      "text/html",
                    ).body.textContent || "";
                  const letterOnlyText = plainText.replace(/[^a-zA-Z ]/g, "");
                  let letterCount = 0;
                  let limitedText = "";
                  for (let i = 0; i < letterOnlyText.length; i++) {
                    if (/[a-zA-Z]/.test(letterOnlyText[i])) {
                      letterCount++;
                    }
                    if (letterCount <= 200) {
                      limitedText += letterOnlyText[i];
                    } else {
                      break;
                    }
                  }
                  return limitedText + (letterCount > 200 ? "..." : "");
                })();

                return (
                  <div
                    className="col-12 col-xl-6 card_box"
                    style={{ transform: "translateY(-25px)" }}
                    key={item.id}
                    data-aos="fade-up"
                    data-aos-delay={Math.min(index * 70, 350)}
                  >
                    <article
                      className="card home-card h-100"
                      style={{ border: "1px solid rgba(23, 58, 155, 0.18)" }}
                    >
                      <div className="home-card__body">
                        <div className="home-card__thumb">
                          <CardImageThumb
                            src={item.tutorial_series_image_b64}
                            alt={item.tutorial_series_name}
                            onOpen={setImageLightboxSrc}
                          />
                        </div>
                        <div className="home-card__content">
                          <Link
                            to={`/tutorial/${toSlug(item.tutorial_series_name)}`}
                            state={{ item }}
                            className="home-card__title"
                          >
                            {item.tutorial_series_name}
                          </Link>
                          <div
                            className="home-card__excerpt para_font_family"
                            dangerouslySetInnerHTML={renderHTML(
                              limitedContentTutorials,
                            )}
                          />
                          <Link
                            to={`/tutorial/${toSlug(item.tutorial_series_name)}`}
                            state={{ item }}
                            className="home-card__read"
                          >
                            Open series →
                          </Link>
                        </div>
                      </div>
                      <div className="home-card__tags">
                        <div className="home-card__footer">
                          <div className="home-card__footer-inner para_font_family text-light">
                            <p style={{ textTransform: "capitalize" }}>
                              <b>Lessons</b> {item.lessons_count}
                            </p>
                            <p>
                              <b>Tech</b> {item.technologies}
                            </p>
                          </div>
                        </div>
                      </div>
                    </article>
                  </div>
                );
              })}
            </div>
            {datas.length < allDatas.length && (
              <div className="text-center mt-2 pt-2" data-aos="zoom-in">
                <button
                  type="button"
                  className="btn btn-dark  px-5 rounded-pill"
                  onClick={() => setSeriesCount(seriesCount + 4)}
                >
                  Load more series
                </button>
              </div>
            )}
          </section>

          {imageLightboxSrc ? (
            <Lightbox
              mainSrc={imageLightboxSrc}
              onCloseRequest={() => setImageLightboxSrc(null)}
            />
          ) : null}
        </>
      )}
    </div>
  );
}
